import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import SelenseApp from "./SelenseApp";

import firebase from "firebase/compat/app";
import "firebase/compat/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDE8XBBP3nlEEtQqUZYyJE8Jk9NoTAhYWk",
  authDomain: "serena-booth.firebaseapp.com",
  projectId: "serena-booth",
  storageBucket: "serena-booth.firebasestorage.app",
  messagingSenderId: "217444123077",
  appId: "1:217444123077:web:a101016957edb274710bac"
};

firebase.initializeApp(firebaseConfig);
window.firebase = firebase;

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
 <React.StrictMode>
 <SelenseApp />
 </React.StrictMode>
);